const includes = {
  doctors: ['practice', 'user', 'offices'],
  practices: ['users']
}

export default includes
